import { Show } from 'solid-js';
import {
  GET_VERIFICATION_CODE,
  PHONE_NUMBER,
  RESEND_VERIFICATION_CODE,
  SIGN_IN,
  SIGN_IN_WITH_EMAIL_AND_PASSWORD,
  SIGN_IN_WITH_MAGIC_LINK,
  VERIFICATION_CODE,
} from '~/assets/strings';
import ActivityIndicator from '~/components/common/activity-indicator/ActivityIndicator';
import { useLocalization } from '~/hooks/useLocalization';
import { LoginType } from '~/types/LoginType';

interface PhoneNumberSignInProps {
  onLoginTypeChange: (type: LoginType) => void;
  onSubmit: (phone: string, code?: string) => void;
  onResendCode: (phone: string) => void;
  isLoading: boolean;
  didSendCode: boolean;
  message?: string;
}

export const PhoneNumberSignIn = (props: PhoneNumberSignInProps) => {
  const { t } = useLocalization();

  return (
    <>
      <div class="flex flex-col gap-1">
        <label class="font-medium text-title-gray" for="phone">
          {t(PHONE_NUMBER)}
          <span class="text-red-500"> *</span>
        </label>
        <input
          type="number"
          placeholder="725123456"
          id="phone"
          name="phone"
          class="no-spinner w-full rounded-md border border-gray-300 px-4 py-3"
          required
        />
      </div>
      <Show when={props.didSendCode}>
        <div class="flex flex-col gap-1">
          <label class="font-medium text-title-gray" for="verificationCode">
            {t(VERIFICATION_CODE)}
            <span class="text-red-500"> *</span>
          </label>
          <input
            type="number"
            placeholder="12345"
            id="verificationCode"
            name="verificationCode"
            class="no-spinner w-full rounded-md border border-gray-300 px-4 py-3"
            required
          />
        </div>
        <button
          type="button"
          onClick={() => {
            const form = document.querySelector('form');
            if (form) {
              const formData = new FormData(form);
              const phone = formData.get('phone') as string;
              if (phone) {
                props.onResendCode(phone);
              }
            }
          }}
          class="mt-4 cursor-pointer text-right text-blue-500 underline hover:text-blue-800">
          {t(RESEND_VERIFICATION_CODE)}
        </button>
      </Show>
      <Show when={props.isLoading}>
        <div class="text-primary mt-4 flex w-full items-center justify-center">
          <ActivityIndicator size={32} />
        </div>
      </Show>
      <Show when={props.message}>
        <div class="text-primary mt-4 flex w-full items-center justify-center">{props.message}</div>
      </Show>
      <button
        type="submit"
        disabled={props.isLoading}
        class="h-16 w-full rounded-md bg-blue-600 font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300">
        {props.didSendCode ? t(SIGN_IN) : t(GET_VERIFICATION_CODE)}
      </button>
      <div class="flex flex-col items-end gap-2">
        <a
          onClick={() => props.onLoginTypeChange(LoginType.Account)}
          class="mt-4 cursor-pointer text-blue-500 underline hover:text-blue-800">
          {t(SIGN_IN_WITH_EMAIL_AND_PASSWORD)}
        </a>
        <a onClick={() => props.onLoginTypeChange(LoginType.MagicLink)} class="cursor-pointer text-blue-500 underline hover:text-blue-800">
          {t(SIGN_IN_WITH_MAGIC_LINK)}
        </a>
      </div>
    </>
  );
};
